'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault(ex) {
	return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var moment = _interopDefault(require('moment'));
require('moment-duration-format');
var React = _interopDefault(require('react'));

// DATE/TIME
var DATE_FORMAT = 'YYYY-MM-DD';

var START_TIME_FORMAT = 'HH:mm';

var DATE_AND_START_TIME_FORMAT = DATE_FORMAT + START_TIME_FORMAT;

var YEAR_FORMAT = 'YYYY';

var SQL_DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss';

var LINK_REST_DATE_FORMAT = 'YYYY-MM-DDTHH:mm';

var FULL_DATE_FORMAT = 'dddd, MMMM D, YYYY';

var LL_FORMAT = 'MMMM D, YYYY';

var HSB_DATE_FORMAT = 'ddd MMM D';

var HSB_START_TIME_FORMAT = 'h:mm A [ET]';

var BOXSCORE_START_TIME_FORMAT = 'dddd, MMMM D, YYYY [-] h:mm A [ET]';

var BIRTH_DATE_FORMAT = 'MMM D[,] YYYY';

var BIRTHDAY_FAKE_TEAM = 'birthday';

var MIN_TEMP_PLAYER_ID = 9000000;

var FIRST_TOI_FACEOFFS_SEASON = 19971998;

var FIRST_SHOTS_AGAINST_SEASON = 19551956;

var FIRST_PPG_SHG_SEASON = 19331934;

var SEASON_WITH_PLAYOFF_OTL = 20192020;

// GAME SCHEDULE TYPES
var SCHEDULED = 1;
var TO_BE_DETERMINED = 2;
var POSTPONED = 3;
var SUSPENDED = 4;
var CANCELLED = 5;

// GAME STATE TYPES
var FUTURE = 1;
var PREGAME = 2;
var LIVE = 3;
var CRITICAL = 4;
var SOFT_FINAL = 5;
var HARD_FINAL = 6;
var OFFICIAL = 7;

// GAME TYPES
var PRE_SEASON = 1;
var REGULAR_SEASON = 2;
var PLAYOFFS = 3;
var ALL_STAR = 4;
var WOMENS_ALL_STAR = 12;

var SEASONS_WITH_TIES_IN_PLAYOFFS = [
	19181919,
	19211922,
	19251926,
	19261927,
	19271928,
	19281929,
	19291930,
	19301931,
	19311932,
	19321933,
	19331934,
	19341935,
	19501951,
];

var constants = Object.freeze({
	DATE_FORMAT: DATE_FORMAT,
	START_TIME_FORMAT: START_TIME_FORMAT,
	DATE_AND_START_TIME_FORMAT: DATE_AND_START_TIME_FORMAT,
	YEAR_FORMAT: YEAR_FORMAT,
	SQL_DATE_FORMAT: SQL_DATE_FORMAT,
	LINK_REST_DATE_FORMAT: LINK_REST_DATE_FORMAT,
	FULL_DATE_FORMAT: FULL_DATE_FORMAT,
	LL_FORMAT: LL_FORMAT,
	HSB_DATE_FORMAT: HSB_DATE_FORMAT,
	HSB_START_TIME_FORMAT: HSB_START_TIME_FORMAT,
	BOXSCORE_START_TIME_FORMAT: BOXSCORE_START_TIME_FORMAT,
	BIRTH_DATE_FORMAT: BIRTH_DATE_FORMAT,
	BIRTHDAY_FAKE_TEAM: BIRTHDAY_FAKE_TEAM,
	MIN_TEMP_PLAYER_ID: MIN_TEMP_PLAYER_ID,
	FIRST_TOI_FACEOFFS_SEASON: FIRST_TOI_FACEOFFS_SEASON,
	FIRST_SHOTS_AGAINST_SEASON: FIRST_SHOTS_AGAINST_SEASON,
	FIRST_PPG_SHG_SEASON: FIRST_PPG_SHG_SEASON,
	SEASON_WITH_PLAYOFF_OTL: SEASON_WITH_PLAYOFF_OTL,
	SCHEDULED: SCHEDULED,
	TO_BE_DETERMINED: TO_BE_DETERMINED,
	POSTPONED: POSTPONED,
	SUSPENDED: SUSPENDED,
	CANCELLED: CANCELLED,
	FUTURE: FUTURE,
	PREGAME: PREGAME,
	LIVE: LIVE,
	CRITICAL: CRITICAL,
	SOFT_FINAL: SOFT_FINAL,
	HARD_FINAL: HARD_FINAL,
	OFFICIAL: OFFICIAL,
	PRE_SEASON: PRE_SEASON,
	REGULAR_SEASON: REGULAR_SEASON,
	PLAYOFFS: PLAYOFFS,
	ALL_STAR: ALL_STAR,
	WOMENS_ALL_STAR: WOMENS_ALL_STAR,
	SEASONS_WITH_TIES_IN_PLAYOFFS: SEASONS_WITH_TIES_IN_PLAYOFFS,
});

/**
 *
 * @param string
 * @returns {string}
 */
var capitalize = function capitalize(string) {
	return string.charAt(0).toUpperCase() + string.slice(1);
};

/**
 *
 * @description Turns a string into hyphen-separated string
 * @resource https://github.com/graphql/graphql.github.io/blob/source/site/_core/Header.js
 * @param str
 * @returns {string}
 */
var toSlug = function toSlug(str) {
	var accents =
		'\xE0\xE1\xE4\xE2\xE8' + '\xE9\xEB\xEA\xEC\xED\xEF' + '\xEE\xF2\xF3\xF6\xF4\xF9' + '\xFA\xFC\xFB\xF1\xE7';

	var without = 'aaaaeeeeiiiioooouuuunc';

	return (
		str

			// Handle uppercase characters
			.toLowerCase()

			// Handle accentuated characters
			.replace(new RegExp('[' + accents + ']', 'g'), function(c) {
				return without.charAt(accents.indexOf(c));
			})

			// Dash special characters
			.replace(/[^a-z0-9]/g, '-')

			// Compress multiple dash
			.replace(/-+/g, '-')

			// Trim dashes
			.replace(/^-|-$/g, '')
	);
};

/**
 *
 * @param slug
 * @requires capitalize
 * @returns {string}
 */
var slugToCamelCase = function slugToCamelCase(slug) {
	return (
		slug

			// Separate string on dashes
			.split('-')

			// Capitalize all elements except the first and return a single string
			.reduce(function(acc, part) {
				return !acc ? part : acc + capitalize(part);
			})
	);
};

/**
 *
 * @param slug
 * @requires capitalize
 * @returns {string}
 */
var slugToSpacedAndHyphenatedCamelCase = function slugToSpacedAndHyphenatedCamelCase(slug) {
	return (
		slug

			// Separate string on dashes
			.split('-')

			// Capitalize all elements except the first and return a single string
			.reduce(function(acc, part) {
				return !acc ? part : acc + ' - ' + capitalize(part);
			})
	);
};

/**
 *
 * @param string
 * @returns {string}
 */
var splitOnUppercase = function splitOnUppercase(string) {
	return (
		string

			// Separate string on capital letters
			.split(/(?=[A-Z)])/)

			// Return a space separated string
			.reduce(function(chunk, acc) {
				return acc ? chunk + ' ' + acc : chunk;
			})
	);
};

/**
 * TODO: Internationalize - accept a unit of measure, return a value based on that unit of measure
 * @param value
 * @returns {string}
 * @format 6' 2"
 */
var displayHeightInFeetAndInches = function displayHeightInFeetAndInches(value) {
	return Math.floor(value / 12) + "' " + Math.round(value % 12) + '"';
};

/**
 *
 * @description Takes a string, removes the space and converts to lowercase
 * @param string
 * @returns {string}
 */
var removeSpaces = function removeSpaces(string) {
	return string.replace(/\s+/g, '').toLowerCase();
};
/**
 * @description Takes a value, returns -- if null/undefined or locale formatted string (Adds Commas). eg. 12,345
 * @param value
 * @returns {string}
 *
 * cellDisplay is used to display the values as formatted strings. This is done on the Cell and not the accessor
 * because sorting integers as strings introduces unexpected results.
 */
var cellDisplay = function cellDisplay(value) {
	return value !== null && value !== undefined ? value.toLocaleString() : '--';
};

var strings = {
	capitalize: capitalize,
	toSlug: toSlug,
	slugToCamelCase: slugToCamelCase,
	slugToSpacedAndHyphenatedCamelCase: slugToSpacedAndHyphenatedCamelCase,
	splitOnUppercase: splitOnUppercase,
	displayHeightInFeetAndInches: displayHeightInFeetAndInches,
	removeSpaces: removeSpaces,
	cellDisplay: cellDisplay,
};

/**
 *
 * @description turns a team name, ie. Sabres into a link to the team page.
 * @param teamCommonName
 * @returns {string} BAM NHL.com team page link
 */
var teamSiteUrl = function teamSiteUrl(teamCommonName) {
	var name = removeSpaces(teamCommonName);
	return 'https://www.nhl.com/' + name;
};

/**
 *
 * @param season
 * @returns {boolean} true if this season is a season in which a game-ending tie occurred during the playoffs, otherwise false
 */
var didTieOccurInPlayoffsForSeason = function didTieOccurInPlayoffsForSeason(season) {
	return SEASONS_WITH_TIES_IN_PLAYOFFS.includes(season);
};

/**
 *
 * @param gameId
 * @returns {boolean} true if this is a Round Robin Playoff game
 */
var isRoundRobinPlayoffGame = function isRoundRobinPlayoffGame(gameId) {
	var game = gameId ? gameId + '' : '';
	if (!game || game.length !== 10) {
		return false;
	}
	var season = game.substring(0, 4);
	var gameType = game.substring(4, 6);
	var gameNumber = parseInt(game.substring(6, 10));

	// For now we are checking the season, but we might be able to remove this check
	return season === '2019' && gameType === '03' && gameNumber < 100;
};

/**
 *
 * @param teamStats
 * @param season
 */
var getRecordForTeamStatsAndSeason = function getRecordForTeamStatsAndSeason(teamStats, season) {
	var wins = teamStats !== undefined ? teamStats.wins : '-';
	var losses = teamStats !== undefined ? teamStats.losses : '-';
	var ties = season.tiesInUse && teamStats !== undefined ? '-' + teamStats.ties : '';
	var overtimeLosses = season.pointForOTLossInUse && teamStats !== undefined ? '-' + teamStats.overtimeLosses : '';

	return wins + '-' + losses + ties + overtimeLosses;
};

var getRecordForTeamStatsSeasonAndGameType = function getRecordForTeamStatsSeasonAndGameType(
	teamStats,
	season,
	gameType
) {
	var wins = teamStats !== undefined ? teamStats.wins : '-';
	var losses = teamStats !== undefined ? teamStats.losses : '-';
	var ties =
		((gameType === REGULAR_SEASON && season.tiesInUse) ||
			(gameType === PLAYOFFS && didTieOccurInPlayoffsForSeason(season.id))) &&
		teamStats !== undefined
			? '-' + teamStats.ties
			: '';
	var overtimeLosses =
		gameType === REGULAR_SEASON && season.pointForOTLossInUse && teamStats !== undefined
			? '-' + teamStats.overtimeLosses
			: '';

	return wins + '-' + losses + ties + overtimeLosses;
};

/**
 *
 * @param period
 * @param gameFormat
 * @param otText
 * @param shootoutText
 * @param localizedMoment
 * @returns {string} All period options. ie. 1st, 2nd, 3rd, OT, SO, 1st OT ...
 * TODO: Add logic for different game types, World Cup, All-Star, Olympics.
 */
var periodsFormatter = function periodsFormatter(period, gameFormat) {
	var otText = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'OT';
	var shootoutText = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'SO';
	var localizedMoment = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : moment();

	if (gameFormat.shootoutInUse && period === gameFormat.maxPeriod) {
		return shootoutText;
	} else {
		return period > gameFormat.regulationPeriods
			? period === gameFormat.regulationPeriods + 1
				? otText
				: localizedMoment.localeData().ordinal(period - gameFormat.regulationPeriods) + ' ' + otText
			: moment.localeData().ordinal(period);
	}
};

/**
 *
 * @param startDate
 * @param endDate
 * @returns {string} Season years formatted as YYYY - YYYY
 * // TODO: Rename this function to better represent what it does.
 */
var seasonFormatter = function seasonFormatter(startDate, endDate) {
	if (endDate == null) {
		endDate = moment(startDate, SQL_DATE_FORMAT).year() + 1;
		return (
			moment(startDate, SQL_DATE_FORMAT).format(YEAR_FORMAT) +
			' - ' +
			moment(endDate, SQL_DATE_FORMAT).format(YEAR_FORMAT)
		);
	}
	return (
		moment(startDate, SQL_DATE_FORMAT).format(YEAR_FORMAT) +
		' - ' +
		moment(endDate, SQL_DATE_FORMAT).format(YEAR_FORMAT)
	);
};

/**
 *
 * @param id
 * @returns {string} season id formatted as YYYY - YYYY
 */
var sluggedSeasonFormatter = function sluggedSeasonFormatter(id) {
	return id.toString().slice(0, 4) + ' - ' + id.toString().slice(4, 8);
};

/**
 *
 * @param id
 * @returns {string} season id formatted as YYYY - YY
 */
var singleSeasonFormatter = function singleSeasonFormatter(id) {
	return id.toString().slice(0, 4) + '-' + id.toString().slice(6, 8);
};

/**
 *
 * @param id
 * @returns {string} season id formatted to YYYY (ex. 19811982 => 1982)
 */
var seasonStartYearFormatter = function seasonStartYearFormatter(id) {
	return '' + id.toString().slice(0, 4);
};

/**
 *
 * @param id
 * @returns {string} season id formatted to YYYY (ex. 19811982 => 1982)
 */
var seasonEndYearFormatter = function seasonEndYearFormatter(id) {
	return '' + id.toString().slice(4, 8);
};

/**
 * @description turns a date, into a season formatted date
 * @param {*} momentDate
 * @returns {int} returns the current season
 */
var getApproximateSeasonByDate = function getApproximateSeasonByDate(momentDate) {
	return momentDate.month() >= 8
		? parseFloat('' + momentDate.year() + (momentDate.year() + 1))
		: parseFloat('' + (momentDate.year() - 1) + momentDate.year());
};

/**
 *
 * @returns {int} returns the current season based on today's Date in season id format
 */
var getCurrentApproximateSeason = function getCurrentApproximateSeason() {
	return getApproximateSeasonByDate(moment());
};

/**
 *
 * @param {int} returns the game type from the game id
 */
var getGameTypeFromGameId = function getGameTypeFromGameId(gameId) {
	return parseInt(gameId.toString().substr(5, 1), 10);
};

var hockey = {
	teamSiteUrl: teamSiteUrl,
	isRoundRobinPlayoffGame: isRoundRobinPlayoffGame,
	getRecordForTeamStatsAndSeason: getRecordForTeamStatsAndSeason,
	getRecordForTeamStatsSeasonAndGameType: getRecordForTeamStatsSeasonAndGameType,
	periodsFormatter: periodsFormatter,
	seasonFormatter: seasonFormatter,
	sluggedSeasonFormatter: sluggedSeasonFormatter,
	singleSeasonFormatter: singleSeasonFormatter,
	seasonStartYearFormatter: seasonStartYearFormatter,
	seasonEndYearFormatter: seasonEndYearFormatter,
	didTieOccurInPlayoffsForSeason: didTieOccurInPlayoffsForSeason,
	getApproximateSeasonByDate: getApproximateSeasonByDate,
	getCurrentApproximateSeason: getCurrentApproximateSeason,
	getGameTypeFromGameId: getGameTypeFromGameId,
};

/**
 * TODO: Make this more generic to handle gameScheduleState
 * @param time
 * @param gameScheduleState
 * @requires moment
 * @returns {moment}
 * @format 7:30 PM
 */
var formatStartTime = function formatStartTime(time, gameScheduleState) {
	if (gameScheduleState.id > SCHEDULED) {
		return gameScheduleState.abbreviation;
	} else {
		return moment(time, START_TIME_FORMAT).format('h:mm A');
	}
};

/**
 *
 * @param game
 * @param headerScoreboard
 * @returns {*}
 */
var displayGameTime = function displayGameTime(game) {
	var headerScoreboard = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

	if (game.state.id <= PREGAME) {
		// 1 or 2
		if (headerScoreboard && game.state.id === PREGAME && game.gameScheduleState.id === SCHEDULED) {
			return 'Pregame';
		}
		return formatStartTime(game.easternStartTime, game.gameScheduleState);
	} else if (game.state.id > PREGAME && game.state.id < SOFT_FINAL) {
		// 3 or 4
		return (
			(periodsFormatter(game.period, game.gameFormat) === 'SO' ? '' : game.timeRemaining) +
			' ' +
			periodsFormatter(game.period, game.gameFormat)
		);
	} else {
		return game.period <= game.gameFormat.regulationPeriods
			? game.timeRemaining
			: game.timeRemaining + ' ' + periodsFormatter(game.period, game.gameFormat);
	}
};

/**
 *
 * @param date
 * @requires moment
 * @returns {moment}
 * @format Wednesday, March 31, 1982
 */
var formatGameDate = function formatGameDate(date) {
	return moment(date, DATE_FORMAT).format(FULL_DATE_FORMAT);
};

/**
 *
 * @param date
 * @requires moment
 * @returns {moment}
 * @format March 31, 1982
 */
var formatBirthDate = function formatBirthDate(date) {
	return moment(date, DATE_FORMAT).format(LL_FORMAT);
};

/**
 *
 * @param date
 * @requires moment
 * @returns {moment}
 * @format 19820331
 */
var formatDateKey = function formatDateKey(date) {
	return moment(date, DATE_FORMAT).format('YYYYMMDD');
};

/**
 *
 * @param seconds
 * @requires moment, moment-duration-format
 * @returns {string} eg. 191.265 => '3:11'
 */
var displaySecondsFormatted = function displaySecondsFormatted(seconds) {
	return seconds !== null ? moment.duration(seconds, 'seconds').format('m:ss', { trim: false }) : '';
};

/**
 *
 * @param data
 * @returns {number}
 */
var averageAgeInYears = function averageAgeInYears(data) {
	var today = moment();
	var combinedAges = data.reduce(function(acc, player) {
		var birthDate = moment(player.birthDate);
		var ageInMilliseconds = today - birthDate;
		return acc + ageInMilliseconds;
	}, 0);

	return Math.round(combinedAges / (1000 * 60 * 60 * 24 * 365.25) / data.length);
};

var displayAgeFromYearsAndDays = function displayAgeFromYearsAndDays(years, days) {
	// This does not account for leap years.
	return (years + days / 365).toFixed(1);
};

var dateTime = {
	formatStartTime: formatStartTime,
	formatGameDate: formatGameDate,
	formatBirthDate: formatBirthDate,
	formatDateKey: formatDateKey,
	displayGameTime: displayGameTime,
	displaySecondsFormatted: displaySecondsFormatted,
	averageAgeInYears: averageAgeInYears,
	displayAgeFromYearsAndDays: displayAgeFromYearsAndDays,
};

/**
 *
 * @description Takes a value and returns a positive(green)/negative(red) or formatted zero(inherited).
 *               Includes color style
 * @param value
 * @param formattedValue
 * @param posColor
 * @param negColor
 * @returns {XML}
 */
var getPosNegCell = function getPosNegCell(_ref) {
	var value = _ref.value,
		formattedValue = _ref.formattedValue,
		_ref$posColor = _ref.posColor,
		posColor = _ref$posColor === undefined ? '#4B9448' : _ref$posColor,
		_ref$negColor = _ref.negColor,
		negColor = _ref$negColor === undefined ? '#D0021B' : _ref$negColor;

	if (formattedValue === null || formattedValue === undefined) {
		formattedValue = value;
	}

	if (value > 0) {
		return React.createElement('span', { className: 'pos', style: { color: posColor } }, '+' + formattedValue);
	} else if (value < 0) {
		return React.createElement('span', { className: 'neg', style: { color: negColor } }, formattedValue);
	} else {
		return React.createElement('span', null, formattedValue);
	}
};

var dom = {
	getPosNegCell: getPosNegCell,
};

var toConsumableArray = function(arr) {
	if (Array.isArray(arr)) {
		for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

		return arr2;
	} else {
		return Array.from(arr);
	}
};

/**
 *
 * @param values (takes an array of values such as [1, 2, 4, 7, 25])
 * @returns {number}
 */
var average = function average(values) {
	return (
		values.reduce(function(sum, value) {
			return sum + value;
		}, 0) / values.length
	);
};

/**
 *
 * @param values (takes an array of values such as [1, 2, 4, 7, 25])
 * @returns {number}
 */
var standardDeviation = function standardDeviation(values) {
	var avg = average(values);

	var squareDiffs = values.map(function(value) {
		var diff = value - avg;
		return diff * diff;
	});

	var avgSquareDiff = average(squareDiffs);

	return Math.sqrt(avgSquareDiff);
};

var statCeiling = function statCeiling(values) {
	return Math.max.apply(Math, toConsumableArray(values));
};

/**
 *
 * @param values
 * @param statType
 * @returns {number}
 */
var statFloor = function statFloor(values, statType) {
	var min = function min(values) {
		return Math.min.apply(Math, toConsumableArray(values));
	};
	var stdDev = standardDeviation(values);

	//edge case for gaa, where maxValue is lower and minValue is higher
	if (statType === 'gaa') {
		if (min - 0.3 > 0) {
			return min - 0.3;
		}

		return 0;
	}

	if (Math.floor(min - stdDev) > 0) {
		return Math.floor(min - stdDev);
	}

	return 0;
};

/**
 *
 * @param ceiling
 * @returns {number}
 */
var multiplier = function multiplier(ceiling) {
	return 100 / ceiling;
};

/**
 * Since JS represents numbers using floating point precision there may be errors. Ex. Math.round(1.005, 2) rounds to 1
 * @param value
 * @param precision
 * @returns {number}
 */
var precisionRound = function precisionRound(value, precision) {
	if (0 > value) {
		return -precisionRound(-value, precision);
	}
	return Number(Math.round(value + 'e' + precision) + 'e-' + precision);
};

/**
 * Since JS represents numbers using floating point precision there may be errors. Ex. Number(1.005).toFixed(2)
 * @param value
 * @param precision
 * @returns {number}
 */
var precisionToFixed = function precisionToFixed(value, precision) {
	return precisionRound(value, precision).toFixed(precision);
};

var math = {
	average: average,
	statCeiling: statCeiling,
	statFloor: statFloor,
	multiplier: multiplier,
	standardDeviation: standardDeviation,
	precisionRound: precisionRound,
	precisionToFixed: precisionToFixed,
};

/**
 *
 * @param numDecimals
 * @return {string}
 */
var decimalFormatter = function decimalFormatter(numDecimals) {
	return function(value) {
		var allowZero = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
		var nullReplacement = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '--';

		return value !== -Infinity &&
			value !== null &&
			!isNaN(value) &&
			value !== undefined &&
			(value !== 0 || allowZero)
			? precisionToFixed(value, numDecimals)
			: nullReplacement;
	};
};

/**
 *
 * @param numDecimals
 * @param truncateLeadingZero
 * @return {string}
 * percentageFormatted is used when a value coming from the database is already formatted as a percentage
 * ie. .1587 is unformatted while 15.87 is formatted.
 * Currently data from mysql is formatted in a number of cases while data from HANA is not.
 */
// TODO CHeck what this will impact
var percentageFormatter = function percentageFormatter(numDecimals) {
	var truncateLeadingZero = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	return function(value) {
		var percentageFormatted = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
		var nullReplacement = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '--';

		if (value === -Infinity || value === null || isNaN(value) || value === undefined) {
			return nullReplacement;
		}
		if (truncateLeadingZero) {
			return precisionToFixed(value, numDecimals).replace(/^0+/, '');
		}
		return percentageFormatted ? precisionToFixed(value, numDecimals) : precisionToFixed(value * 100, numDecimals);
	};
};

/**
 *
 * @param value
 * @returns {number}
 */
var shootingPlusSavePctgFormatter = function shootingPlusSavePctgFormatter(value) {
	return Math.ceil(Number(value) * 1000);
};

/**
 *
 * @param value
 * @returns {string}
 * ie.  This is to differentiate between players for whom we will never have shooting percentage.
 *      That is, historic players that we don't have shot information for.
 *      The -- indicates that they could have a shooting percentage eventually. The blank indicates they never will.
 */
var displayNAOrNullValue = function displayNAOrNullValue(value) {
	return value === null ? '' : '--';
};

var displayValueAs = function displayValueAs(columnId) {
	var formattingFunction = void 0;

	switch (columnId) {
		// 1 Decimal cells (non-percentages)
		case 'avgWins':
		case 'avgPoints':
		case 'avgGoals':
		case 'avgShotLength':
		case 'blockedShotsPerGame':
		case 'hitsPerGame':
		case 'missedShotsPerGame':
		case 'shotsAgainstPerGame':
		case 'avgShotsAgainstPerGame':
		case 'avgShotsPerGame':
		case 'shotsForPerGame':
		case 'avgShiftsPerGame':
		case 'shiftsPerGame':
		case 'avgPenaltyMinutesPerGame':
			formattingFunction = decimalFormatter(1);
			break;

		// 1 Decimal cells (percentages)
		case 'shootingPctg':
		case 'shootoutShootingPctg':
		case 'penaltyShotShootingPctg':
		case 'fiveOnFiveShootingPctg':
		case 'faceoffPctg':
		case 'faceoffWinPctg':
		case 'faceoffWinPercentage':
		case 'faceoffWinPctgDefensiveZone':
		case 'faceoffWinPctgNeutralZone':
		case 'faceoffWinPctgOffensiveZone':
		case 'evFaceoffWinPctg':
		case 'ppFaceoffWinPctg':
		case 'shFaceoffWinPctg':
		case 'homePkPctg':
		case 'penaltyKillPercentage':
		case 'penaltyKillPctg':
		case 'pkPctg':
		case 'roadPkPctg':
		case 'powerplayPercentage':
		case 'ppPctg':
		case 'roadPpPctg':
		case 'homePpPctg':
			formattingFunction = percentageFormatter(1);
			break;

		// 2 Decimal cells (non-percentage)
		case 'assistsPer60Minutes':
		case 'goalsAgainstPerGame':
		case 'avgGoalsAgainstPerGame':
		case 'goalsForPerGame':
		case 'avgGoalsPerGame':
		case 'goalsPer60Minutes':
		case 'penaltiesDrawnPer60Minutes':
		case 'penaltiesPer60Minutes':
		case 'pointsPer60Minutes':
		case 'goalsAgainstAverage':
		case 'assistsPerGame':
		case 'assistsPerGpMin35':
		case 'avgAssistsPerGame':
		case 'goalsPerGame':
		case 'goalsPerGpMin20':
		case 'goalsPerGpMin50':
		case 'avgPointsPerGame':
		case 'pointsPerGame':
		case 'pointsPerGpMin50':
		case 'shotsPerGame':
		case 'goals5on5ForAgainstRatio':
			formattingFunction = decimalFormatter(2);
			break;

		// 2 Decimal cells (percentage)
		case 'shotAttemptsRelPctg':
		case 'unblockedShotAttemptsRelPctg':
		case 'shotAttemptsPctg':
		case 'shotAttemptsPctgAhead':
		case 'shotAttemptsPctgBehind':
		case 'shotAttemptsPctgClose':
		case 'shotAttemptsPctgTied':
		case 'unblockedShotAttemptsPctg':
		case 'unblockedShotAttemptsPctgAhead':
		case 'unblockedShotAttemptsPctgBehind':
		case 'unblockedShotAttemptsPctgClose':
		case 'unblockedShotAttemptsPctgTied':
		case 'zoneStartPctg':
			formattingFunction = percentageFormatter(2);

			break;

		// 3 Decimal Cells - no leading zero
		case 'evSavePctg':
		case 'fiveOnFiveSavePctg':
		case 'pointPctg':
		case 'pointPercentage':
		case 'ppSavePctg':
		case 'psSavePctg':
		case 'savePctg':
		case 'savePercentage':
		case 'shSavePctg':
		case 'shootoutSavePctg':
		case 'winPctg':
		case 'winPctg1GoalGame':
		case 'winPctg2GoalGame':
		case 'winPctg3GoalGame':
		case 'winPctgAfterLead1p':
		case 'winPctgAfterLead2p':
		case 'winPctgAfterTrail1p':
		case 'winPctgAfterTrail2p':
		case 'winPctgOpponentScore1st':
		case 'winPctgScore1st':
			formattingFunction = percentageFormatter(3, true);
			break;

		case 'shootingPlusSavePctg':
			formattingFunction = shootingPlusSavePctgFormatter;
			break;

		default:
			formattingFunction = function formattingFunction(value) {
				return value;
			};
			break;
	}

	return formattingFunction;
};

var averageStatValueForTeam = function averageStatValueForTeam(data, stat) {
	var combinedStats = data.reduce(function(acc, item) {
		return acc + item[stat];
	}, 0);

	return combinedStats / data.length;
};

var stats = {
	decimalFormatter: decimalFormatter,
	percentageFormatter: percentageFormatter,
	shootingPlusSavePctgFormatter: shootingPlusSavePctgFormatter,
	displayValueAs: displayValueAs,
	displayNAOrNullValue: displayNAOrNullValue,
	averageStatValueForTeam: averageStatValueForTeam,
};

exports.constants = constants;
exports.dateTimeFormatter = dateTime;
exports.domFormatter = dom;
exports.hockeyFormatter = hockey;
exports.mathFormatter = math;
exports.statFormatter = stats;
exports.stringFormatter = strings;
